const APP_ONLY_PREFIXES = ['/api/', '/storage/', '/images/', '/fonts/', '/css/', '/js/', '/vendor/', '/build/', '/favicon']

function joinBase(base: string, path: string): string {
  if (base === '') {
    return path
  }
  const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base

  return `${normalizedBase}${path}`
}

/**
 * Resolve an API media URL for the SPA. Absolute URLs on the API host with `/storage/`
 * are rebased onto `VITE_MEDIA_PUBLIC_URL` when set. Other absolute URLs pass through.
 * Spatie keys (`/{id}/file`) join `VITE_MEDIA_PUBLIC_URL` when set.
 * API, `/storage` fallback, and baked public assets stay on `VITE_API_BASE_URL`.
 */
export function resolveAssetUrl(url: string): string {
  const trimmed = url.trim()
  if (trimmed === '') {
    return trimmed
  }
  const mediaBase = ((import.meta.env.VITE_MEDIA_PUBLIC_URL as string | undefined) ?? '').trim()
  const apiBase = ((import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '').trim()

  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('//')) {
    if (mediaBase !== '' && apiBase !== '') {
      try {
        const absolute = new URL(trimmed.startsWith('//') ? `https:${trimmed}` : trimmed)
        const apiOrigin = new URL(apiBase).origin
        if (absolute.origin === apiOrigin && absolute.pathname.startsWith('/storage/')) {
          const mediaPath = absolute.pathname.slice('/storage'.length)
          return joinBase(mediaBase, mediaPath === '' ? '/' : mediaPath)
        }
      } catch {
        return trimmed
      }
    }
    return trimmed
  }

  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`
  const staysOnApi = APP_ONLY_PREFIXES.some((prefix) => path.startsWith(prefix))
  const base = !staysOnApi && mediaBase !== '' ? mediaBase : apiBase

  return joinBase(base, path)
}
